import React from 'react';
import {AisinoFormItem, AisinoInputNumber} from "../../../baseComponent/form";
import {formItemTailLayout} from "../../../constant/css";

class FormItemNumInput extends React.Component {

    render() {
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):""
        return(
            <AisinoFormItem {...formItemTailLayout} {...this.props}  onChange={this.props.onChangeItem}>
                <AisinoInputNumber
                    style={this.props.style?{...this.props.style,background:styleBg?"#ffffe6":""}:{width: "100%",background:styleBg?"#ffffe6":""}}
                    autoComplete="off"
                    formatter={this.props.formatter}
                    parser={this.props.parser}
                    disabled={this.props.disabled}
                    onChange={this.props.onChange}
                    min={0}
                />
            </AisinoFormItem>
        );
    }
}
export default FormItemNumInput;